import * as product from '@/api/product'

// 简介的banner图
export function fetchBanner() {

	const param = {
		client: 0
	}

	return new Promise(function(resolve, reject){
		product.getBanner(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.imgUrl = result.data

				resolve(responseBody)
			})
	})
}

// 提交解决方案
export function submitSolution(form) {

	return new Promise(function(resolve, reject){
		product.submitSolution(form)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.solution = result.data

				resolve(responseBody)
			})
	})
}

// 获取新的产品列表 需求发生变更后新增的方法
export function getProductList() {

    const param = new Object()
    param.language = 'zh'

    return new Promise(function(resolve, reject){
        product.getList(param)
            .then(function(result) {

                resolve(result.data.list)
            })
    })
}

// 获取产品列表
export function fetchProductList(query) {

	const param = new Object()

	param.current_page = query.current_page
	param.type = 0

	if(query.msg) {
		param.msg = query.msg
	}

	return new Promise(function(resolve, reject){
		product.getProductList(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.list = result.data

				resolve(responseBody)
			})
	})
}

// 获取产品搜索热词
export function fetchHotWords() {

	return new Promise(function(resolve, reject){
		product.getHotWords()
			.then(function(result) {

				let responseBody = new Object()
				responseBody.list = result.data
				resolve(responseBody)
			})
	})
}

// 获取产品详情
export function fetchProductDetails(id) {

	const param = {
		id: id
	}

	return new Promise(function(resolve, reject){
		product.getProductDetails(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.list = result.data

				resolve(responseBody)
			})
	})
}

// 添加记录
export function add(id) {

    const param = {
        id: id
    }

    product.addRecord(param)
        .then(function(result) {})
}

// 获取产品搜索热词
export function fetchProductImg(id) {

	const param = {
		id: id
	}

	return new Promise(function(resolve, reject){
		product.getProductImg(param)
			.then(function(result) {

				let responseBody = new Object()
				responseBody.img = result.data
				resolve(responseBody)
			})
	})
}

// 发送问题
export function sendQuestion(question) {

    const param = {
        question: question
    }

    return new Promise(function(resolve, reject){
        product.fetchAnswer(param)
            .then(function(result) {

                // let responseBody = new Object()


                resolve(result)
            })
    })
}